import { Icon, Toast } from '@revolut-internal/ui-kit'

export const CopyToClipboardSuccessToast = () => {
  return (
    <Toast>
      <Toast.Indicator>
        <Icon name="Check" size={20} />
      </Toast.Indicator>
      <Toast.Label>Copied to clipboard</Toast.Label>
    </Toast>
  )
}
